import { BrowserDate } from './browser-date';

export function ServerDate(...args) {
  // Check if called without 'new'
  if (this instanceof ServerDate) {
    // Called with 'new', create and return a new instance
    // @ts-ignore
    const modifiedDate = new BrowserDate(...args);

    // Set the prototype to CustomDate.prototype
    Object.setPrototypeOf(modifiedDate, ServerDate.prototype);

    /**
     * Don't adjust if timestamp or ServerDate instance is passed:
     * - new Date(value)
     * - new Date(dateObject)
     */
    if (!(args.length === 1 && (typeof args[0] === 'number' || typeof args[0] === 'object'))) {
      adjust(modifiedDate);
    }

    return modifiedDate;
  } else {
    // Called without 'new', return a string with the current date
    // @ts-ignore
    return adjust(new BrowserDate()).toString();
  }
}

// Ensure instances of ServerDate are also instances of BrowserDate
ServerDate.prototype = Object.create(BrowserDate.prototype);

ServerDate.UTC = function(): number {
  return BrowserDate.UTC.apply(BrowserDate, Array.from(arguments));
};

ServerDate.now = function(): number {
  return BrowserDate.now() + ServerDate.offset;
};

ServerDate.parse = function(d: string): number {
  return BrowserDate.parse(d) + ServerDate.offset;
};

ServerDate.offset = 0;
ServerDate.setOffset = function (offset: number) {
  ServerDate.offset = offset;
}

function adjust(d) {
  d.setMilliseconds(d.getMilliseconds() + ServerDate.offset);

  return d;
}
